import type { CityConfig } from "@/pages/city-template/types";

export const levittownConfig: CityConfig = {
  city: "Levittown",
  state: "New York",
  stateAbbr: "NY",
  slug: "levittown",
  route: "/cities/levittown",
  title: "Emergency & Expedited Passport Levittown NY | Nassau County",
  metaDescription:
    "Emergency passport Levittown NY — same day, 24-hour, and 3-5 day expedited passport processing for Levittown and Central Nassau County. Fast Passport Center serves Wantagh, East Meadow, Hicksville, and Massapequa.",
  h1: "Emergency & Expedited Passport Services in Levittown, NY",
  heroSubtitle:
    "Levittown's fast passport solution for Central Nassau County travelers. Whether you're flying out of JFK, LaGuardia, or Long Island MacArthur, Fast Passport Center delivers emergency passports in as little as 24 hours and expedited processing in 3-5 days.",
  heroImageUrl:
    "https://readdy.ai/api/search-image?query=Levittown%20Long%20Island%20New%20York%20suburban%20neighborhood%20at%20golden%20hour%20with%20classic%20mid-century%20ranch%20homes%2C%20tree-lined%20streets%2C%20manicured%20lawns%2C%20warm%20amber%20afternoon%20light%2C%20nostalgic%20American%20suburban%20community%20scene%2C%20modern%20travel%20photography%20with%20clean%20composition%2C%20no%20text%20overlay%2C%20scenic%20Nassau%20County%20Long%20Island%20New%20York%20residential%20street&width=1600&height=700&seq=ny-levittown-hero-001&orientation=landscape",
  heroImageAlt: "Levittown New York suburban neighborhood with classic mid-century homes at golden hour",
  geoPosition: "40.7259; -73.5143",
  geoPlacename: "Levittown, New York, United States",
  lastModified: "2026-05-31",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "~25 miles (via LIRR or Northern State Parkway)",
  },
  nearbyCitiesZips: [
    { name: "Levittown", zips: "11756, 11714" },
    { name: "Wantagh", zips: "11793" },
    { name: "East Meadow", zips: "11554" },
    { name: "Hicksville", zips: "11801, 11802, 11815, 11819, 11854, 11855" },
    { name: "Massapequa", zips: "11758, 11762" },
    { name: "Massapequa Park", zips: "11762" },
    { name: "North Massapequa", zips: "11758" },
    { name: "Seaford", zips: "11783" },
    { name: "Bellmore", zips: "11710" },
    { name: "North Bellmore", zips: "11710" },
    { name: "Merrick", zips: "11566" },
    { name: "Bethpage", zips: "11714" },
    { name: "Plainedge", zips: "11714" },
    { name: "Farmingdale", zips: "11735, 11737" },
    { name: "Old Bethpage", zips: "11804" },
    { name: "Plainview", zips: "11803" },
    { name: "Syosset", zips: "11773, 11791" },
    { name: "Woodbury", zips: "11797" },
    { name: "Jericho", zips: "11753" },
    { name: "Westbury", zips: "11568, 11590, 11594, 11595, 11597" },
    { name: "Garden City", zips: "11530, 11531, 11535, 11599" },
    { name: "Mineola", zips: "11501" },
    { name: "Hempstead", zips: "11550, 11551, 11552, 11553, 11554, 11555, 11556, 11557" },
    { name: "Uniondale", zips: "11553, 11555, 11556" },
    { name: "Roosevelt", zips: "11575" },
    { name: "Freeport", zips: "11520" },
    { name: "Baldwin", zips: "11510" },
    { name: "Rockville Centre", zips: "11570, 11571, 11572" },
    { name: "Lynbrook", zips: "11563, 11564" },
    { name: "Valley Stream", zips: "11580, 11581, 11582" },
    { name: "Elmont", zips: "11003" },
    { name: "Floral Park", zips: "11001, 11002, 11005" },
    { name: "New Hyde Park", zips: "11040, 11041, 11042, 11043, 11044, 11099" },
    { name: "Great Neck", zips: "11020-11027" },
    { name: "Port Washington", zips: "11050, 11052, 11053, 11054, 11055, 11051" },
    { name: "Roslyn", zips: "11576, 11577" },
    { name: "Manhasset", zips: "11030" },
    { name: "Bay Shore", zips: "11706, 11769" },
    { name: "Islip", zips: "11751, 11752" },
    { name: "Commack", zips: "11725" },
    { name: "Smithtown", zips: "11745, 11754, 11780, 11787, 11788" },
    { name: "Huntington", zips: "11743, 11721, 11740, 11746, 11747, 11750" },
    { name: "West Babylon", zips: "11704, 11707" },
    { name: "North Babylon", zips: "11703" },
    { name: "Lindenhurst", zips: "11757" },
    { name: "Amityville", zips: "11701, 11702, 11708, 11726" },
    { name: "Copiague", zips: "11726, 11757" },
    { name: "Long Island", zips: "11001-11980" },
    { name: "New York City", zips: "10001-10282" },
    { name: "Brooklyn", zips: "11201-11256" },
    { name: "Queens", zips: "11001-11697" },
    { name: "Jamaica", zips: "11430, 11432, 11433, 11434, 11435, 11436" },
    { name: "Stamford", zips: "06901-06907" },
    { name: "Bridgeport", zips: "06601-06608" },
    { name: "Norwalk", zips: "06850-06860" },
  ],
  benefits: [
    {
      icon: "ri-time-line",
      title: "As Fast as 24 Hours",
      desc: "Emergency passport processing for Levittown travelers with urgent departures — same day service available for documented emergencies.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Registered Courier",
      desc: "U.S. Department of State registered passport courier with direct access to the New York Passport Agency.",
    },
    {
      icon: "ri-customer-service-2-line",
      title: "Real Human Support",
      desc: "Dedicated agents guide you through every step — no chatbots, no automated runaround. Available for Levittown residents 7 days a week.",
    },
    {
      icon: "ri-map-pin-line",
      title: "Central Nassau County",
      desc: "Levittown, Wantagh, East Meadow, Hicksville, and all of Central Nassau County — we serve the entire Levittown area.",
    },
  ],
  testimonials: [
    {
      name: "Christina D.",
      location: "Levittown, NY",
      rating: 5,
      text: "Had a last-minute business trip to Toronto in 5 days. Fast Passport Center got my expedited passport processed in 3 days. The agent was incredibly helpful and walked me through every step.",
      service: "Expedited Passport",
    },
    {
      name: "Anthony M.",
      location: "Wantagh, NY",
      rating: 5,
      text: "Renewed my passport for a family vacation to Aruba. Chose the 5-day option and had it back in 4. They caught a small error on my form before submission that would have caused a delay.",
      service: "Passport Renewal",
    },
    {
      name: "Patricia K.",
      location: "East Meadow, NY",
      rating: 5,
      text: "First-time passport for my grandson's exchange program. The agent helped us with the DS-11 form and guided us to the acceptance clerk at the Hicksville Post Office. Processed in 5 days.",
      service: "New Passport",
    },
  ],
  facilities: [
    {
      id: "levittown-1",
      name: "Hicksville Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "17 West John Street",
      city: "Hicksville",
      state: "NY",
      zip: "11801",
      phone: "516-433-2222",
      hours: "Mon-Fri 8:00 AM - 5:00 PM, Sat 9:00 AM - 1:00 PM",
      distance: "~3 miles from Levittown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major Nassau County passport acceptance facility serving Levittown, Hicksville, Bethpage, and Plainview. First-time applicants and those not eligible for mail-in renewal must apply in person.",
      icon: "ri-building-2-line",
    },
    {
      id: "levittown-2",
      name: "Massapequa Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "5250 Sunrise Highway",
      city: "Massapequa",
      state: "NY",
      zip: "11758",
      phone: "516-797-5200",
      hours: "Mon-Fri 9:00 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "~4 miles from Levittown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available by appointment. Convenient for Levittown, Wantagh, Seaford, and Massapequa residents.",
      icon: "ri-building-2-line",
    },
    {
      id: "levittown-3",
      name: "Garden City Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "245 Stewart Avenue",
      city: "Garden City",
      state: "NY",
      zip: "11530",
      phone: "516-222-5100",
      hours: "Mon-Fri 9:00 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "~8 miles from Levittown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major passport acceptance facility serving Nassau County. Additional option for Levittown residents near the Garden City area.",
      icon: "ri-building-2-line",
    },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Levittown?",
      a: "Fast Passport Center offers same-day emergency passport processing in as little as 24 hours for Levittown residents with documented life-or-death emergencies. For urgent travel within 2 weeks, our 3-5 day expedited service is the most popular option. Standard processing through the post office takes 8-11 weeks.",
    },
    {
      q: "Where is the closest passport acceptance facility in Levittown?",
      a: "The Hicksville Post Office at 17 West John Street is approximately 3 miles from Levittown and is a major Nassau County passport acceptance facility. The Massapequa Post Office at 5250 Sunrise Highway is about 4 miles away. First-time applicants and those not eligible for mail-in renewal must apply in person.",
    },
    {
      q: "Can I get same-day passport photos in Levittown?",
      a: "Yes — passport photos are available at CVS Pharmacy, Walgreens, UPS Store, and FedEx Office locations throughout Levittown, Wantagh, Hicksville, and East Meadow. We also offer photo review as part of our service to ensure your 2x2 photos meet all State Department requirements.",
    },
    {
      q: "How much does an expedited passport cost in Levittown?",
      a: "Government fees are set by the State Department and vary based on passport type (book vs card, large book option). Fast Passport Center's service fees depend on processing speed: 10-day Smart Saver, 3-5 day Expedited, or 24-hour Emergency. Call 877-253-0084 for a personalized quote based on your Levittown passport needs.",
    },
    {
      q: "Do I need to visit the New York Passport Agency in person?",
      a: "No — if you use Fast Passport Center, you do not need to visit the New York Passport Agency in Manhattan. As a registered courier, we handle the agency submission for you. Levittown residents can simply ship documents via overnight courier. The only reason to visit the agency directly is for a documented life-or-death emergency, and appointments are extremely difficult to obtain.",
    },
    {
      q: "What is the fastest way to renew a passport in Levittown?",
      a: "The fastest way to renew a passport in Levittown is through Fast Passport Center's 3-5 day expedited service. If your most recent passport was issued when you were 16 or older, within the last 15 years, and is undamaged, you may qualify for renewal without an acceptance clerk visit. For even faster renewal, our 24-hour emergency service is available.",
    },
    {
      q: "Can I get a child passport expedited in Levittown?",
      a: "Yes — Fast Passport Center expedites child passports for minors under 16 in Levittown and all of Central Nassau County. Both parents must appear with the child or provide notarized consent (Form DS-3053). We review all parental consent documentation before submission to avoid delays.",
    },
    {
      q: "Does Fast Passport Center have an office in Levittown?",
      a: "Fast Passport Center operates as a remote courier service — we do not have a physical office in Levittown. We serve Levittown and Central Nassau County through our secure overnight shipping and agency submission process. Our headquarters are in Washington, DC.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Levittown", address: "various CVS locations in Levittown, Wantagh, Hicksville, and East Meadow", hours: "Mon-Sun, hours vary by location" },
    { name: "Walgreens — Levittown Area", address: "various Walgreens locations throughout Levittown, Wantagh, and Massapequa", hours: "Mon-Sun, hours vary by location" },
    { name: "UPS Store — Levittown", address: "various UPS Store locations in Levittown and surrounding Nassau County", hours: "Mon-Fri 9:00 AM - 7:00 PM, Sat 10:00 AM - 4:00 PM" },
    { name: "FedEx Office — Levittown", address: "various FedEx Office locations near Levittown and Hicksville", hours: "Mon-Fri 8:00 AM - 9:00 PM, Sat-Sun 10:00 AM - 6:00 PM" },
    { name: "Walmart Photo Center — Levittown", address: "Walmart locations near Levittown and Hicksville", hours: "Mon-Sun 8:00 AM - 10:00 PM" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Hempstead",
      address: "50 Clinton Street, Hempstead, NY 11550",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Major Nassau County DMV office for license renewals and REAL ID applications. Convenient for Levittown, East Meadow, and Wantagh residents. Appointments strongly recommended.",
      featured: true,
    },
    {
      name: "NYS DMV — Medford",
      address: "2699 Route 112, Medford, NY 11763",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Suffolk County DMV office serving South Shore communities. Alternative option for Levittown residents near the Suffolk County border.",
      featured: false,
    },
    {
      name: "NYS DMV — Huntington",
      address: "200 East Main Street, Huntington, NY 11743",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Suffolk County DMV office serving North Shore communities including Huntington, Northport, and Commack.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "JFK",
      name: "John F. Kennedy International Airport",
      distance: "~15 miles from Levittown",
      address: "JFK Access Road, Jamaica, NY 11430",
      note: "Major international gateway with direct flights to Europe, Asia, and worldwide destinations. Accessible via LIRR or Southern State Parkway from Levittown.",
      flightUrl: "https://www.jfkairport.com/",
      flightLabel: "JFK Airport",
      featured: true,
    },
    {
      code: "LGA",
      name: "LaGuardia Airport",
      distance: "~20 miles from Levittown",
      address: "Ditmars Boulevard, Flushing, NY 11369",
      note: "Domestic-focused airport with flights to major U.S. cities. Accessible via LIRR or car from Levittown.",
      flightUrl: "https://www.laguardiaairport.com/",
      flightLabel: "LaGuardia Airport",
      featured: true,
    },
    {
      code: "ISP",
      name: "Long Island MacArthur Airport",
      distance: "~20 miles from Levittown",
      address: "100 Arrival Avenue, Ronkonkoma, NY 11779",
      note: "Long Island's own airport with flights to Florida, the Caribbean, and major U.S. hubs. Accessible via Long Island Expressway from Levittown.",
      flightUrl: "https://www.macarthurairport.com/",
      flightLabel: "MacArthur Airport",
      featured: true,
    },
  ],
  services: [
    {
      icon: "ri-passport-line",
      title: "Emergency Passport",
      description: "For Levittown travelers with urgent departures within 24 hours to 2 weeks. Direct New York Passport Agency submission with dedicated courier handling.",
      bullets: ["Processing as fast as 24 hours", "Dedicated agent assigned to your case", "Daily status updates"],
      badge: "Fastest",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Fast renewal for Levittown residents with a valid passport issued within the last 15 years at age 16 or older.",
      bullets: ["3-5 day or 10-day options available", "No acceptance clerk visit required", "Secure overnight document return"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-user-add-line",
      title: "New Passport",
      description: "First-time passport application assistance for Levittown residents with step-by-step guidance through the acceptance clerk process.",
      bullets: ["Complete application review before submission", "Acceptance clerk appointment guidance", "3-5 day or 10-day processing options"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alarm-warning-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement service for Levittown residents who have lost their passport or had it stolen.",
      bullets: ["DS-64 form guidance included", "Replacement in 3-5 days or 10 days", "Acceptance clerk visit required"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 in Levittown, with parental consent guidance and acceptance clerk support.",
      bullets: ["Parental consent documentation review", "Both parents present or notarized consent", "3-5 day or 10-day processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal name change for Levittown residents.",
      bullets: ["Marriage certificate or court order review", "Name change in 3-5 days or 10 days", "No clerk visit for most renewals"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Levittown travelers with immediate departure needs from JFK, LaGuardia, or Long Island MacArthur Airport." },
    { name: "Passport Renewal", description: "Fast passport renewal for Levittown residents with a recent valid passport." },
    { name: "New Passport", description: "First-time passport application assistance for Levittown residents." },
    { name: "Lost or Stolen Passport", description: "Passport replacement for Levittown residents who have lost their passport." },
    { name: "Child Passport", description: "Passport services for minors under 16 in Levittown and Central Nassau County." },
    { name: "Name Change", description: "Passport name change service after marriage, divorce, or legal name change in Levittown." },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Photos must be 2\"x2\" with a plain white or off-white background. Many Levittown travelers get rejected at the acceptance clerk because their photos don't meet strict State Department specs.",
    },
    {
      icon: "ri-file-list-3-line",
      title: "Missing or Incorrect Forms",
      description: "Using the wrong form (DS-11 vs DS-82) or missing required fields can cause weeks of delays. We review every form before submission.",
    },
    {
      icon: "ri-calendar-line",
      title: "Waiting Too Long to Start",
      description: "Standard processing takes 8-11 weeks. Many Levittown travelers wait until the last minute, leaving no buffer for problems.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Incorrect Payment Amount",
      description: "Government fees change frequently. Using an outdated check or wrong amount will cause your application to be returned.",
    },
    {
      icon: "ri-shield-line",
      title: "Damaged or Expired ID",
      description: "Your driver's license or state ID must be valid and unexpired. Many applicants don't realize their ID is about to expire until it's too late.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For child passports, both parents must appear or provide notarized consent. Missing documentation is the #1 reason child applications are delayed.",
    },
  ],
  steps: [
    {
      number: "01",
      icon: "ri-file-list-3-line",
      title: "Complete Your Application",
      description: "Fill out your passport application online or over the phone with our Levittown team. We review everything for accuracy.",
    },
    {
      number: "02",
      icon: "ri-upload-cloud-line",
      title: "Send Us Your Documents",
      description: "Ship your documents via overnight courier from Levittown to our secure processing center. We confirm receipt and begin review immediately.",
    },
    {
      number: "03",
      icon: "ri-search-line",
      title: "We Review Everything",
      description: "Our agents verify your forms, photos, and supporting documents meet all State Department requirements — no surprises.",
    },
    {
      number: "04",
      icon: "ri-shield-check-line",
      title: "Courier Submission",
      description: "As a registered U.S. Department of State courier, we submit your application directly to the New York Passport Agency.",
    },
    {
      number: "05",
      icon: "ri-passport-line",
      title: "Receive Your Passport",
      description: "Your passport is delivered securely to your Levittown address. We provide tracking and daily status updates throughout.",
    },
  ],
  processingOptions: [
    {
      speed: "8-11",
      unit: "weeks",
      label: "Standard Processing",
      tag: "Post Office",
      tagColor: "bg-gray-200 text-gray-600",
      features: [
        "Mail-in application",
        "No expedited handling",
        "No dedicated agent",
        "No phone or email contact for your case",
        "Updates only by physical mail letter",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "10",
      unit: "business days",
      label: "Smart Saver",
      tag: "Fast Passport Center",
      tagColor: "bg-green-100 text-green-700",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned",
        "Daily status updates",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "3-5",
      unit: "business days",
      label: "Expedited Processing",
      tag: "Recommended",
      tagColor: "bg-[#1A365D] text-white",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "24",
      unit: "hours",
      label: "Emergency Processing",
      tag: "Life or Death",
      tagColor: "bg-red-100 text-red-600",
      features: [
        "For documented life-or-death emergencies only",
        "Requires proof of emergency travel",
        "Strictly for documented life-or-death emergencies",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Must book weeks in advance", fpc: "No appointment needed — we handle agency access" },
    { feature: "Processing Speed", agency: "1-2 business days (if you get an appointment)", fpc: "As fast as 3-5 days or 24 hours for emergencies" },
    { feature: "Document Review", agency: "No pre-check — one mistake means restart", fpc: "Complete review before submission — we catch errors" },
    { feature: "Travel Proof", agency: "Requires printed itinerary with confirmed travel within 2 weeks", fpc: "Flexible documentation requirements" },
    { feature: "Updates", agency: "No phone or email support — only mail updates", fpc: "Daily status updates via phone and email" },
    { feature: "Guarantee", agency: "No guarantee of appointment or same-day processing", fpc: "Reserved agency slots with predictable processing" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "New York City", route: "/cities/new-york-city" },
    { name: "Brooklyn", route: "/cities/brooklyn" },
    { name: "Queens", route: "/cities/queens" },
    { name: "The Bronx", route: "/cities/the-bronx" },
    { name: "Staten Island", route: "/cities/staten-island" },
    { name: "Long Island", route: "/cities/long-island" },
    { name: "Bay Shore", route: "/cities/bay-shore" },
    { name: "Commack", route: "/cities/commack" },
    { name: "Hicksville", route: "/cities/hicksville" },
    { name: "Huntington", route: "/cities/huntington" },
    { name: "Islip", route: "/cities/islip" },
    { name: "Smithtown", route: "/cities/smithtown" },
    { name: "West Babylon", route: "/cities/west-babylon" },
    { name: "Buffalo", route: "/cities/buffalo" },
    { name: "Albany", route: "/cities/albany-ny" },
    { name: "Rochester", route: "/cities/rochester" },
    { name: "Syracuse", route: "/cities/syracuse" },
    { name: "Yonkers", route: "/cities/yonkers" },
    { name: "New York State", route: "/states/new-york" },
  ],
  fpcOfficeNote:
    "Fast Passport Center serves Levittown and all of Central Nassau County as a remote courier service. We do not have a physical office in Levittown, but our secure overnight shipping network ensures your documents reach our processing center quickly and safely.",
  fpcOfficeDistance: "Remote courier service — Levittown area",
  serviceAreaIntro:
    "Fast Passport Center provides expedited passport services to Levittown and all of Central Nassau County. From Levittown to Wantagh, from East Meadow to Hicksville — we serve the entire Central Nassau area with fast, reliable processing.",
  nearbyCitiesIntro:
    "We proudly serve Levittown and all surrounding communities across Central Nassau County. Whether you're in Wantagh, East Meadow, Massapequa, or Bethpage, our expedited passport services are available to you.",
  howItWorksIntro:
    "Our Levittown customers follow a simple, proven process to get their passports fast. No agency visits, no waiting in lines, no guessing.",
  mistakesIntro:
    "These are the most common mistakes Levittown travelers make when applying for an expedited passport. Avoiding them saves weeks of delays.",
  testimonialsIntro:
    "Levittown travelers trust Fast Passport Center for their urgent passport needs. Here's what they say about our service.",
  faqIntro:
    "Common questions about emergency and expedited passport services in Levittown. If you don't see your question here, call us at 877-253-0084.",
  statePageRoute: "/states/new-york",
  statePageName: "New York Passport Services",
};

export default levittownConfig;